import {createSelector} from 'reselect';
import columns from '../../../../../../react-table/helpers/columns';
import {summaryColumns, weekColumns} from '../../../common/redux/selectors/DespatchPerformanceMetadataMapper';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getData = ReportsDefinition.POST_TO_POST_DESPATCH_PERFORMANCE.getDataFunction();

const getMetadata = state => state.reporting.POST_TO_POST_DESPATCH_PERFORMANCE.metadata;

export const getGeneratedOnDateTime = state => getMetadata(state) && getMetadata(state).generatedOnDateTime;

export const getIsLoading = state => state.reporting.POST_TO_POST_DESPATCH_PERFORMANCE.isLoading;

export const getColumns = createSelector(getMetadata, getData, (metadata, data) => {
  if (!metadata || !metadata.weeks) {
    return [];
  }
  const { TextColumn } = columns(data);
  const weekColumnsFlat = weekColumns(metadata.weeks, data)?.flat();

  return [
    new TextColumn('Origin Post', 'originPostalOperator').withTotalHeader('Total'),
    new TextColumn('Responding Post', 'destinationPostalOperator'),
    ...summaryColumns(metadata.weeks, data),
    ...weekColumnsFlat
  ];
});
